import { openModal, closeModal } from "./modal.js";

const menu = document.querySelector("#main-navigation");
const logo = document.querySelector("#site-logo");
const hamburger = document.querySelector("#hamburger");
const openIcon = hamburger.querySelector(".menuIcon");
const closeIcon = hamburger.querySelector(".closeIcon");

const privMenu = document.querySelector("#member-navigation");
const privHamburger = document.querySelector("#member-hamburger");

// Toggle nav
hamburger.addEventListener("click", function () {
  menu.classList.contains("translate-x-full") ? openNav() : closeNav();
});

if (privMenu) {
  const privOpenIcon = privHamburger.querySelector(".menuIcon");
  const privCloseIcon = privHamburger.querySelector(".closeIcon");

  privHamburger.addEventListener("click", function () {
    privMenu.classList.contains("hidden")
      ? openPrivateNav()
      : closePrivateNav();
  });
}

// Set height on window resize
window.addEventListener("resize", () => {
  setNavHeight();
});

// Calculate the scroll position of the sticky nav, and resize components accordingly
window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;
  const topNavHeight = 68;
  const memberNavHeight = document.querySelector("#member-navigation") ? 60 : 0;

  if (scrollY > topNavHeight + memberNavHeight) {
    logo.classList.add("sm:!h-12", "sm:translate-y-8.5");
  } else {
    logo.classList.remove("sm:!h-12", "sm:translate-y-8.5");
  }

  setNavHeight();
});

// Toggle subnav
document.querySelectorAll(".subnav-toggle").forEach((el) => {
  el.addEventListener("click", (e) => toggleSubnav(el));
});

const openNav = () => {
  menu.classList.remove("translate-x-full");
  hamburger.classList.add("bg-orange");
  openIcon.classList.add("hidden");
  closeIcon.classList.remove("hidden");

  setNavHeight();

  if (window.innerWidth < 640) {
    openModal();
  }
};

const closeNav = () => {
  menu.classList.add("translate-x-full");
  hamburger.classList.remove("bg-orange");
  openIcon.classList.remove("hidden");
  closeIcon.classList.add("hidden");
  closeModal();
  closeAllSubnavs();
};

const openPrivateNav = () => {
  privMenu.classList.remove("hidden");
  privOpenIcon.classList.add("hidden");
  privCloseIcon.classList.remove("hidden");

  closeNav();
  openModal();
};

const closePrivateNav = () => {
  privMenu.classList.add("hidden");
  privOpenIcon.classList.remove("hidden");
  privCloseIcon.classList.add("hidden");
  closeModal();
};

const closeAllSubnavs = () => {
  document.querySelectorAll(".subnav").forEach((subnav) => {
    subnav.classList.remove("grid-rows-[1fr]");
  });

  document.querySelectorAll(".subnav-toggle svg").forEach((icon) => {
    icon.classList.remove("rotate-90");
  });
};

const toggleSubnav = (el) => {
  let target = el.nextElementSibling;
  let icon = el.querySelector("svg");

  if (window.innerWidth < 1200) {
    event.preventDefault();

    const isOpen = target.classList.contains("grid-rows-[1fr]");

    closeAllSubnavs();

    if (!isOpen) {
      target.classList.add("grid-rows-[1fr]");
      icon.classList.add("rotate-90");
    }
  }
};

const setNavHeight = () => {
  const scrollY = window.scrollY;
  const navHeight = 0;
  const topNavHeight = 68;
  const memberNavHeight = document.querySelector("#member-navigation") ? 48 : 0;
  const headerHeight = navHeight + topNavHeight + memberNavHeight;

  let top = navHeight + (topNavHeight + memberNavHeight - scrollY);
  top = top < navHeight ? navHeight : top > headerHeight ? headerHeight : top;

  if (window.innerWidth < 640) {
    top = navHeight;
  }

  menu.style.top = `${top}px`;
};
